"use client";

import { useContext, type ReactNode } from "react";
import Box from "@mui/material/Box";
import type { PuckBlockProps } from "../types";
import { PageFlowContext } from "../PageFlowContext";
import {
  isPageContentVisible,
  pageVisibilityPhase,
  type PageVisibilityPhase,
} from "../pageVisibility";

export interface PageVisibilityContext {
  phase?: PageVisibilityPhase;
  isFirstQuestion?: boolean;
  readOnly?: boolean;
}

export function PageVisibility({
  when,
  phase = "questions",
  isFirstQuestion = true,
  readOnly = false,
  children,
}: Pick<PuckBlockProps["Visibility"], "when"> & PageVisibilityContext & { children: ReactNode }) {
  const flow = useContext(PageFlowContext);
  if (flow) {
    phase = pageVisibilityPhase(flow.flowState);
    isFirstQuestion = flow.isFirstQuestionStep;
  }
  const visible = isPageContentVisible(when, phase, isFirstQuestion);
  if (visible) return <>{children}</>;
  if (readOnly) return null;

  return (
    <Box
      data-testid="landing-page-hidden-content"
      sx={{ border: "1px dashed #98a2b3", p: 1.5, minWidth: 0 }}
    >
      <Box sx={{ fontSize: 12, color: "#475467", bgcolor: "#f2f4f7", px: 1, py: 0.5, mb: 1 }}>
        {when === "hidden"
          ? "Hidden content — available to edit"
          : `Visible ${when.replaceAll("-", " ")}`}
      </Box>
      {children}
    </Box>
  );
}
